import { render } from "./AdminProducts.vue?vue&type=template&id=2a17dc43&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"

import "./AdminProducts.vue?vue&type=style&index=0&id=2a17dc43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a17dc43"]])

export default __exports__